module.exports = __webpack_public_path__ + "static/media/ic_zoom_out_dark.8cfbc7e4.svg";